import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { formattedDate3 } from '../../../helper/utils/formattedDate';
import { isEmptyObject } from '../../../helper/utils/isEmptyObject';
import { urlNavigate } from '../../../helper/utils/navigation';
import { safeJsonParse } from '../../../helper/utils/safeJsonParse';
import { groupBy } from '../../../helper/utils/utils.misc';
import { doGetProductsAvailability, doGetProductsDaysAvailability, doHandleAddToCart, doHandleState, doHandleUpdateItemCart } from '../../../redux/onlineSales/onlineSales.actions';
import { doHandleStateOnlineSalesParty } from '../../../redux/onlineSalesProcess/onlineSalesProcess.actions';

export default function useOnlineSales() {
    const dispatch = useDispatch();

    const { data = [], detail = {}, cart = [], loadingOrder = false, loading = false, selectedDate = '', loadingDetail = false, selectedDetailDate = null, selectedDetailTimeslot = null, selectedDetailRooms = [], selectedAddonsDetail = [], availabilityStatusActive = false, selectedDetailCurrentDate = null, outlets: outletData = [], page = {} } = useSelector((state) => state?.onlineSales);
    const [params, serSearhParams] = useSearchParams();
    const { roomPartyAvailability } = useSelector((state) => state?.onlineSalesProcess);

    const groupedData = groupBy(data, 'pageName');
    const availability = detail?.availability ?? [];
    const sessions = (detail?.sessions ?? []).map((s) => s?.sessionName ?? '');
    const outlet = safeJsonParse(localStorage.getItem('outlet'), {});
    const outlets = outletData.length > 0 ? outletData : safeJsonParse(localStorage.getItem('outlets'), []);
    const brand = safeJsonParse(localStorage.getItem('brand'), {});
    const callbackUrl = params.get('callback-url') || `${urlNavigate('online-sales', 'home')}`;

    //* HARDCODE Menu with Min Qty, karena dari backoffice belum ada
    const productsWithMinQty = [
        {
            menuCode: 'SPI0101035',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101036',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'TSI0101021',
            minQty: 4,
            maxQty: 99,
        },
        {
            menuCode: 'TSI0101022',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'TSI0101023',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'PPI0101026',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'TSI0101024',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'TSI0101025',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101046',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'PPI0101103',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'PPI0101101',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101039',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101037',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101043',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101041',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101054',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101052',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101056',
            minQty: 2,
            maxQty: 99,
        },
        {
            menuCode: 'SPI0101057',
            minQty: 2,
            maxQty: 99,
        },
        // {
        //     menuCode: '',
        //     minQty: 1,
        //     maxQty: 99,
        // },
    ];

    const handleGetProductAvailability = (type = '', date = '') => {
        dispatch(doHandleState('data', []));
        dispatch(doGetProductsAvailability({ type, date, brandCode: brand['brandCode'] || '', outletCode: outlet['outletCode'] || '', callbackUrl }));
    };

    const handleGetProductDetails = (productId = '', date = '', days = 30, outletCode = outlet['outletCode'] || '') => {
        dispatch(doGetProductsDaysAvailability({ productId, date, days, outletCode }));
        dispatch(doHandleStateOnlineSalesParty('roomPartyAvailability', {}));
    };

    const handleAddToCart = (payload, onSuccess) => {
        dispatch(doHandleAddToCart(payload, onSuccess));
    };

    const handleEditCart = (payload, onSuccess) => {
        dispatch(doHandleUpdateItemCart(payload, onSuccess));
    };

    const handleSelectDate = (date = '') => {
        handleSelectDetailDate(date);
    };

    const handleSelectDetailDate = (date = '') => {
        const currentDate = formattedDate3(date);
        const getAvailability = availability.find((item) => item.date === currentDate);
        const isActive = ((getAvailability || {})['availability'] || '') == 'available';

        dispatch(doHandleState('availabilityStatusActive', isActive));
        dispatch(doHandleState('selectedDetailDate', date));
        dispatch(doHandleState('selectedDate', date));
    };

    const handleSelectDetailTimeslot = (date = '') => {
        dispatch(doHandleState('selectedDetailTimeslot', date));
    };

    const handleToggleDetailRoom = (room = {}) => {
        const isExist = selectedDetailRooms.some((item) => item.roomCode === room.roomCode);
        let newRooms = [];
        if (isExist) {
            newRooms = selectedDetailRooms.filter((item) => item.roomCode !== room.roomCode);
        } else {
            newRooms = [...selectedDetailRooms, room];
        }
        dispatch(doHandleState('selectedDetailRooms', newRooms));
    };

    const handleSelectAddonDetail = (item = {}, qty = 0) => {
        const isExist = selectedAddonsDetail.some((addon) => {
            const menuPackageItemId = String(addon?.menuPackageItemId ?? '');

            if (menuPackageItemId) {
                return menuPackageItemId === String(item?.menuPackageItemId ?? '');
            }

            return addon.menuCode === item.menuCode;
        });

        let newAddons = [];

        if (qty > 0) {
            if (isExist) {
                newAddons = selectedAddonsDetail.map((addon) => (addon.menuCode === item.menuCode ? { ...addon, qty } : addon));
            } else {
                newAddons = [...selectedAddonsDetail, { ...item, qty }];
            }
        } else {
            newAddons = selectedAddonsDetail.filter((addon) => addon.menuCode !== item.menuCode);
        }

        dispatch(doHandleState('selectedAddonsDetail', newAddons));
    };

    const isCartContainTimeSlot = () => {
        if (cart.length > 0) {
            return !isEmptyObject(cart.find((item) => !isEmptyObject(item['timeSlot'])) || {});
        }

        return false;
    };

    const isCartContainDate = () => {
        if (cart.length > 0) {
            const dates = cart.find((item) => item['date'] != null || item['date'] != '') || {};
            return !isEmptyObject(dates);
        }

        return false;
    };

    const handleSelectDetailCurrentDate = (date) => {
        dispatch(doHandleState('selectedDetailCurrentDate', date));
    };

    const getMinQty = (menu) => {
        const menuCode = typeof menu === 'string' ? menu : menu?.menuCode;
        const minQty = typeof menu === 'object' ? menu?.minQty : null;

        if (minQty !== undefined && minQty !== null && Number(minQty) > 0) {
            return Number(minQty);
        }

        const product = productsWithMinQty.find((item) => item.menuCode === menuCode);
        return product ? product.minQty : 0;
    };

    const getMaxQty = (menu) => {
        const menuCode = typeof menu === 'string' ? menu : menu?.menuCode;
        const maxQty = typeof menu === 'object' ? menu?.maxQty : null;

        if (maxQty !== undefined && maxQty !== null && Number(maxQty) > 0) {
            return Number(maxQty);
        }

        const product = productsWithMinQty.find((item) => item.menuCode === menuCode);

        return product ? product.maxQty : 99;
    };

    return {
        cart,
        data,
        groupedData,
        detail,
        sessions,
        availability,
        loadingOrder,
        loadingDetail,
        loading,
        selectedDate,
        outlet,
        brand,
        selectedDetailDate,
        selectedDetailTimeslot,
        selectedDetailRooms,
        selectedAddonsDetail,
        callbackUrl,
        outlets,
        availabilityStatusActive,
        selectedDetailCurrentDate,
        handleSelectDetailCurrentDate,
        handleGetProductAvailability,
        handleGetProductDetails,
        handleAddToCart,
        handleSelectDate,
        isCartContainTimeSlot,
        handleSelectDetailDate,
        handleSelectDetailTimeslot,
        handleToggleDetailRoom,
        handleSelectAddonDetail,
        handleEditCart,
        getMinQty,
        getMaxQty,
        isCartContainDate,
        page,
        roomPartyAvailability,
    };
}
